import { Action } from 'redux';

import { ChangeRemoteExtractRefresh } from '../../app/actions/AppActionTypes';
import { IRemoteRefreshScheduleInfo } from '../models/IRemoteRefreshScheduleInfo';

export interface ChangeRemoteExtractRefreshAction extends Action {
  schedule: IRemoteRefreshScheduleInfo;
}

export function changeRemoteExtractRefresh(schedule: IRemoteRefreshScheduleInfo): ChangeRemoteExtractRefreshAction {
  return {
    type: ChangeRemoteExtractRefresh,
    schedule,
  };
}
